import React, { Component } from "react";
import ResponsiveReactGridLayout from "react-grid-layout";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import {
  NotificationContainer,
  NotificationManager
} from "react-notifications";
import "react-notifications/lib/notifications.css";

class Debug extends Component {
  constructor() {
    super();
    this.state = {
      termine: [],
      title: null,
      from: null,
      to: null,
      allDay: false,
      layout: [
        { i: "gallery1", x: 0, y: 0, w: 1, h: 1, static: true, autoSize: true },
        { i: "gallery2", x: 1, y: 0, w: 1, h: 1, static: true, autoSize: true },
        { i: "gallery3", x: 2, y: 0, w: 1, h: 1, static: true, autoSize: true },
        { i: "gallery4", x: 0, y: 1, w: 1, h: 1, static: true, autoSize: true }
      ],
      mailtoTemplate:
        "mailto:merlin.scheurer@Yahoo.de?subject=Tambourkorps Termine&body=",
      mailto: null
    };
  }

  saveing() {
    if (this.state.title === null) {
      NotificationManager.error("Der Termin hat keinen Namen.", "Achtung!");
      return;
    }
    if (this.state.from === null) {
      NotificationManager.error("Der Termin hat kein Von Datum.", "Achtung!");
      return;
    }
    if (this.state.to === null) {
      NotificationManager.error("Der Termin hat kein Bis Datum.", "Achtung!");
      return;
    }

    let obj = {};
    obj.title = this.state.title;
    obj.start = this.state.from;
    obj.end = this.state.to;
    obj.allDay = this.state.allDay;
    let aray = this.state.termine;
    aray.push(obj);
    this.setState({ termine: aray });
    this.updateMailto();
    NotificationManager.success("Gespeichert", "Erfolgreich");
  }

  updateMailto() {
    let text = this.state.mailtoTemplate;
    text += JSON.stringify(this.state.termine);
    this.setState({ mailto: text });
  }

  handleDate(date) {
    this.setState({ from: date._d });
  }

  handleDate2(date) {
    this.setState({ to: date._d });
  }

  setTitle() {
    this.setState({ title: document.getElementById("textbox").value });
  }

  render() {
    return (
      <div className="debugScreen">
        <ResponsiveReactGridLayout
          className="layout"
          layout={this.state.layout}
          cols={3}
          rowHeight={350}
          width={1200}
          useCSSTransforms={true}
        >
          <div key={"gallery1"} className="clearfix">
            1. Beginn Datum und Uhrzeit:
            <DateTime locale="de-de" onChange={this.handleDate.bind(this)} />
          </div>
          <div key={"gallery2"} className="clearfix">
            2. End Datum und Uhrzeit:
            <DateTime locale="de-de" onChange={this.handleDate2.bind(this)} />
          </div>
          <div key={"gallery3"} className="clearfix">
            3. Ganztags? :
            <input
              type="checkbox"
              value="Ganztags"
              onClick={() => {
                this.setState({ allDay: !this.state.allDay });
              }}
            />
            <br />
            4. Bezeichnung:
            <input
              type="text"
              id="textbox"
              onChange={this.setTitle.bind(this)}
            />
            <br />
            <br />
            <button
              className="btn btn-success"
              onClick={this.saveing.bind(this)}
            >
              5. Zur Liste Hinzufügen
            </button>
            <br />
            Fertig? =>
            <u>
              <a href={this.state.mailto}>Verschicken</a>
            </u>
          </div>
          <div key={"gallery4"} className="clearfix">
            Termin liste:
            <br />
            {JSON.stringify(this.state.termine)}
          </div>
        </ResponsiveReactGridLayout>
        <NotificationContainer />
      </div>
    );
  }
}

export default Debug;



// WEBPACK FOOTER //
// ./src/components/debug.js